import { render, staticRenderFns } from "./transportMain.vue?vue&type=template&id=3f279939"
import script from "./transportMain.vue?vue&type=script&lang=js"
export * from "./transportMain.vue?vue&type=script&lang=js"
import style0 from "./transportMain.vue?vue&type=style&index=0&id=3f279939&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VRow,VTab,VTabItem,VTabs})
